import EntityWithIdStore from "./EntityWithIdStore";

class BillingTypeStoreClass extends EntityWithIdStore {
    constructor()
    {
        super();
        this.defaultBillingTypeId = -1;
    }

    getDefaultBillingType()
    {
        return this.get(this.getDefaultBillingTypeId());
    }

    getDefaultBillingTypeId()
    {
        return this.defaultBillingTypeId;
    }

    setDefaultBillingTypeId(defaultBillingTypeId)
    {
        this.defaultBillingTypeId = defaultBillingTypeId;
    }
}

const BillingTypeStore = new BillingTypeStoreClass();
export default BillingTypeStore;


// WEBPACK FOOTER //
// ./web/js/store/BillingTypeStore.js